import angular from 'angular';

import { Transaction } from '../model/transaction';

angular
  .module('cxHttpServices')
  .factory('transactionHttpSvc', ['$http', 'appUrls', '$q', transactionHttpSvc]);

function transactionHttpSvc($http, appUrls, $q) {
  var baseUrl = appUrls.api + '/api/Transaction/';
  var basePaymentUrl = appUrls.api + '/api/Payment/';

  function handleSuccess(response) {
    return response.data;
  }

  function transformArray(response) {
    return response.data.map(function(val) {
      return new Transaction(val);
    });
  }
  //return $http.get(baseUrl + 'Open', { params: { sort: ['date', 'name'], take: 50, skip: 0, search: { name: 'e' }, filter: { name: { items: ['Kenji','Test'] } } } }).then(transformArray);
  function getTransactions(params) {
    var deferred = $q.defer();
    return $http
      .get(`${baseUrl}Get/`, {
        params: params,
        timeout: deferred.promise,
        cancel: deferred,
      })
      .then(transformArray);
  }

  return {
    getTransactions,
    openTransactions: params => getTransactions({ ...params, closed: false }),
    closedTransactions: params => getTransactions({ ...params, closed: true }),
    matchTransaction: function(transId) {
      return $http.get(baseUrl + 'Match/' + transId).then(handleSuccess);
    },
    matchAllTransactions: function(params) {
      return $http.get(baseUrl + 'MatchAll', { params }).then(handleSuccess);
    },
    createTransaction: function(transaction) {
      return $http.post(baseUrl + 'Post', transaction).then(function(response) {
        return new Transaction(response.data);
      });
    },
    updateTransaction: function(transaction) {
      return $http.put(baseUrl + 'Put', transaction).then(handleSuccess);
    },
    unarchiveTransaction: function(transaction) {
      return $http.post(baseUrl + 'Unarchive', transaction).then(handleSuccess);
    },
    removeTransaction: function(transId) {
      return $http.delete(baseUrl + 'Delete/' + transId).then(handleSuccess);
    },
    createPayment: function(transId, payment) {
      return $http.post(basePaymentUrl + 'Post/' + transId, payment).then(handleSuccess);
    },
    updatePayment: function(payment) {
      return $http.put(basePaymentUrl + 'Put', payment);
    },
    removePayment: function(paymentId) {
      return $http.delete(basePaymentUrl + 'Delete/' + paymentId);
    },
    createLink: function(documentId, payment) {
      return $http.post(basePaymentUrl + 'Link/' + documentId, payment).then(handleSuccess);
    },
    updateLink: function(payment) {
      return $http.put(basePaymentUrl + 'Link', payment);
    },
    removeLink: function(paymentId) {
      return $http.delete(basePaymentUrl + 'Link/' + paymentId);
    },
    getLinkableDocs: function(invoiceId) {
      return $http.get(basePaymentUrl + 'LinkableDocuments/' + invoiceId).then(handleSuccess);
    },
  };
}
